import Preferences from './Preferences.js'
import './Preferences.scss'
export default Preferences
